require('../step.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');

//@helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatCurrency } = require('utilities/currencyHelper');
const { ACCOUNT_CANCEL_CHECKS_DETERIORATED,
        ACCOUNT_CANCEL_CHECKS_LOST,
        ACCOUNT_CANCEL_CHECKS_STOLEN,
        ZERO_UP_TO_SEVEN_ALPHANUMERIC_CHARACTERS,
        FIRST_STEP } = require('constants/index');

//@actions
const accountCancelChequesActions = require('actions/accountCancelCheques');

//@commons
const { InputSafe } = require('commonsComponents/inputSafe');
const { AmountInput } = require('commonsComponents/amountInput');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { OKMessage } = require('commonsComponents/OKMessage');

class AccountCancelChequesStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'number': props.immAccountCancelCheques.getIn(['steps', FIRST_STEP, 'number'])
        };

        this.handleNumberBlur = this.handleNumberBlur.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { setupFirstStep, immCheque, immAccount, chequebookIndex } = this.props;

        setupFirstStep({
            chequebookIndex,
            accountId: immAccount.get('accountId'),
            range: {
                first: parseInt(immCheque.get('initialNum'), 10),
                last: parseInt(immCheque.get('finalNum'), 10)
            }
        })
    }

    handleNumberBlur(evt) {
        this.props.handleNumberBlur(evt.target.value);
    }

    handleNumberChange(evt) {
        if (ZERO_UP_TO_SEVEN_ALPHANUMERIC_CHARACTERS.test(evt.target.value)) {
            this.setState({
                number: evt.target.value
            });
        }
    }

    render() {
        const { immAccountCancelCheques, handleReasonChange, handleAmountChange, immAccount } = this.props;
        const { number } = this.state;
        const immStep = immAccountCancelCheques.getIn(['steps', FIRST_STEP]);
        const amount = immStep.get('amount') || '';
        const initialNum = immStep.getIn(['range', 'first']) || 0;
        const finalNum = immStep.getIn(['range', 'last']) || 0;
        const validNumber = parseInt(immStep.get('number'), 10);
        const numberInRange = validNumber >= initialNum && validNumber <= finalNum;
        const reason = immStep.get('reason');
        const baseFormatText = 'accountCancelCheques-';
        const numberLabel = formatText(`${baseFormatText}number`);
        const knownAmountLabel = formatText(`${baseFormatText}knownAmount`);
        const instructionsMessage = formatText('accountCancelCheques-rangeMessage', [
            initialNum,
            finalNum
        ]);
        const currencySymbol = formatCurrency(immAccount.getIn(['balance', 'currency']));
        const isNumberValid = immStep.get('isNumberValid');
        const isAlreadyCancelled = immStep.get('isAlreadyCancelled');
        let numberError, numberErrorMessageKey;

        if (immStep.get('isNumberDirty')) {
            if (!isNumberValid || !numberInRange) {
                numberErrorMessageKey = 'invalidNumberField'
            } else if (isAlreadyCancelled) {
                numberErrorMessageKey = 'alreadyCancelled';
            }

            numberError = !isNumberValid || !numberInRange || isAlreadyCancelled;
        }

        const numberErrorMessage = formatText(`${baseFormatText}${numberErrorMessageKey}`);

        return (
            <article className="account-cancel-cheques-step">
                <header className="account-cancel-cheques-step__header">
                    <h5 className="account-cancel-cheques-step__title">
                        <FormattedText value="accountCancelCheques-firstStepTitle" />
                    </h5>
                </header>
                <section className="account-cancel-cheques-step__content">
                    <form className="account-cancel-cheques-step__form">
                        <fieldset className="account-cancel-cheques-step__field">
                            <label>{numberLabel}</label>
                            <p className="account-cancel-cheques-step__field-message">{instructionsMessage}</p>
                            <InputSafe
                                type="text"
                                name="number"
                                value={number}
                                errorState={numberError}
                                errorMessage={numberErrorMessage}
                                onBlur={this.handleNumberBlur}
                                onChange={this.handleNumberChange}
                            />
                        </fieldset>

                        <fieldset className="account-cancel-cheques-step__amount">
                            <AmountInput
                                name="knownAmount"
                                amount={amount}
                                min={0}
                                maxIntegerLength={9}
                                callback={handleAmountChange}
                                disablePaste
                                hideFocusZero
                                label={knownAmountLabel}
                                language={getLanguage()}
                            />
                        </fieldset>
                        <div className="account-cancel-cheques-step__currency-symbol">
                            {currencySymbol}
                        </div>
                        <fieldset className="account-cancel-cheques-step__field">
                            <h6 className="account-cancel-cheques-step__subtitle">
                                <FormattedText value="accountCancelCheques-firstStepReasonSubtitle" />
                            </h6>
                            <RadioButtonGroup
                                name="reason"
                                idPrefix="cancelChequesReasonRadio"
                                selectedValue={reason}
                                onChange={handleReasonChange}
                                className="block-step__radio-group"
                            >
                                <RadioButton label={formatText('accountCancelCheques-firstStepReason1Label')} value={ACCOUNT_CANCEL_CHECKS_DETERIORATED} className="block-step__radio"/>
                                <RadioButton label={formatText('accountCancelCheques-firstStepReason2Label')} value={ACCOUNT_CANCEL_CHECKS_LOST} className="block-step__radio"/>
                                <RadioButton label={formatText('accountCancelCheques-firstStepReason3Label')} value={ACCOUNT_CANCEL_CHECKS_STOLEN} className="block-step__radio"/>
                            </RadioButtonGroup>
                        </fieldset>
                        <div className="account-cancel-cheques-step__warning-text">
                            <OKMessage type="important">
                                <FormattedText value="accountCancelCheques-warningText" />
                            </OKMessage>
                        </div>
                    </form>
                </section>
            </article>
        );
    }
}

AccountCancelChequesStep1.propTypes = {
    immCheque: PropTypes.object,
    immAccountCancelCheques: PropTypes.object,
    handleNumberBlur: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleReasonChange: PropTypes.func.isRequired,
    setupFirstStep: PropTypes.func.isRequired,
    immAccount: PropTypes.object,
    chequebookIndex: PropTypes.string.isRequired
};

module.exports.constructor = AccountCancelChequesStep1;
module.exports.AccountCancelChequesStep1 = connect(null, {
    handleNumberBlur: accountCancelChequesActions.numberChanged,
    handleAmountChange: accountCancelChequesActions.amountChanged,
    handleReasonChange: accountCancelChequesActions.reasonChanged,
    setupFirstStep: accountCancelChequesActions.setupFirstStep
})(AccountCancelChequesStep1);